// extracted by mini-css-extract-plugin
module.exports =  {"page":"PageSpinner-YidM__page","message":"PageSpinner-mOKp__message","spinner":"PageSpinner-tMJV__spinner","intro":"PageSpinner-XEvE__intro"};